import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import { useLocation } from "react-router-dom";

import { CustomTabs, LoadingGray } from "../../../components";
import BreadCrumbsMUI from "../../../components/molecules/breadcrumpMUI/breadcrumpMUI";
import { TMuiOptionTabType } from "../../../components/molecules/custom-tab/custom-tab";
import { useUser } from "../../../context";
import { useFetch } from "../../../hooks";
import { TProject } from "../../../models";
import { projects } from "../../../services";
import * as s from "./styled-project";
import { TabActivities } from "./tab-activities/tab-activities";
import AnnotationTab from "./tab-annotation/annotation-tab";
import { TabCollabs } from "./tab-collabs/tab-collabs";
import { DashboardTab } from "./tab-dashboard/dashaboard-tab";
import { TabDescription } from "./tab-description/tab-description";
import FilesTab from "./tab-files/files-tab";
import TabGantt from "./tab-gantt/tab-gantt";

const rotes = [
    {
        label: "Projetos",
        href: "/projetos",
    },
];

export const Project = () => {
    const { verifyPermission, user } = useUser();
    const viewProjectsPermission = verifyPermission({
        id: "projects_sectors",
        rule: "view",
    });

    const organizationPermission = verifyPermission({
        id: "manage_teams_projects",
        rule: "enabled",
    });

    const location = useLocation();
    const [project, setProject] = useState<TProject>({
        ...location?.state?.project,
        Users: [],
    });
    const [loading, setLoading] = useState<boolean>(true);
    const [isLoadingPage, setIsLoadingPage] = useState(true);

    const getProject = useFetch({
        fn: projects.getProject,
        start: false,
    });

    const currentRouteName = location?.state?.project?.name ?? "";

    const baseOptions: TMuiOptionTabType = isLoadingPage
        ? []
        : [
              {
                  title: "DASHBOARD",
                  content: <DashboardTab project={project} />,
              },
              {
                  title: "ATIVIDADES",
                  content: (
                      <TabActivities loading={loading} project={project} />
                  ),
              },
              {
                  title: "GANTT",
                  content: <TabGantt project={project} />,
              },
              {
                  title: "TIME",
                  content: (
                      <TabCollabs project={project} getProject={getProject} />
                  ),
              },
              {
                  title: "DESCRIÇÃO",
                  content: (
                      <TabDescription
                          project={project}
                          getProject={getProject}
                          loading={loading}
                          setLoading={setLoading}
                      />
                  ),
              },
              {
                  title: "ANEXOS",
                  content: (
                      <FilesTab project={project} getProject={getProject} />
                  ),
              },
              {
                  title: "ANOTAÇÕES",
                  content: (
                      <AnnotationTab
                          project={project}
                          getProject={getProject}
                      />
                  ),
              },
          ];

    const filteredByOrganization = organizationPermission
        ? baseOptions
        : baseOptions.filter((option) => option.title !== "DASHBOARD");

    const tabOptions = !viewProjectsPermission
        ? filteredByOrganization.filter(
              (option) =>
                  option.title !== "DESCRIÇÃO" && option.title !== "TIME"
          )
        : filteredByOrganization;

    useEffect(() => {
        if (getProject.error) {
            toast.error(`${getProject.error}`);
            setLoading(getProject.loading);
            setIsLoadingPage(false);
        }

        if (getProject.response) {
            setProject(getProject.response.projects[0]);
            setLoading(getProject.loading);
        }
    }, [getProject.response, getProject.error, getProject.loading]);

    useEffect(() => {
        const permissionsReady =
            typeof viewProjectsPermission === "boolean" &&
            typeof organizationPermission === "boolean";

        if (project && permissionsReady && !getProject.loading) {
            setIsLoadingPage(false);
        }
    }, [
        project,
        viewProjectsPermission,
        organizationPermission,
        getProject.loading,
    ]);

    useEffect(() => {
        if (location?.state?.project?.id_e) {
            getProject.onRefresh({
                projectId: location?.state?.project?.id_e,
                users: true,
                hours: true,
                finished: false,
                sectors: true,
                reviewers: true,
                all: true,
            });
        }
    }, [location?.state?.project?.id_e]);

    return (
        <>
            <s.Header>
                <BreadCrumbsMUI
                    breadcrumpRotes={rotes}
                    currentRote={currentRouteName}
                />
            </s.Header>

            <s.Container>
                {isLoadingPage ? (
                    <Box
                        width="100%"
                        height="60vh"
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                    >
                        <LoadingGray />
                    </Box>
                ) : (
                    <CustomTabs tabOptions={tabOptions} />
                )}
            </s.Container>
        </>
    );
};
